import { createSelector } from 'reselect';
import { getProp } from '../../utilities';
import { tarrifByTicketIdxSelector } from '../Passengers/selectors';

const stepperDetailDomainSelector = state => state.stepper;
const ticketsDomainSelector = state => state.tickets;
const connectionParamsDomainSelector = state => state.connectionParams;

export const summarySelector = createSelector(
  stepperDetailDomainSelector,
  ticketsDomainSelector,
  connectionParamsDomainSelector,
  tarrifByTicketIdxSelector,
  (substate, tickets, params, tarrifsByIdxSector) => {
    const firstWayId = getProp(substate, [
      'stepParams',
      'firstWay',
      'connectionId',
    ]);
    const secondWayId = getProp(substate, [
      'stepParams',
      'secondWay',
      'connectionId',
    ]);

    const passengers = getProp(substate, ['stepParams', 'passengers']);
    const ticketsForWays = getProp(
      tickets,
      [
        'byConnectionInfo',
        `${params.ticketType},${firstWayId},${secondWayId}`,
        'tickets',
      ],
      [],
    );
    let ticketWithPersons = [];
    ticketsForWays.forEach((ticke, index) => {
      let ticketsForPersons = [];
      if (passengers) {
        passengers.forEach(passanger => {
          if (passanger.ticket) {
            ticketsForPersons = [
              ...ticketsForPersons,
              {
                ...passanger,
                tarrif: {
                  ...tarrifsByIdxSector[index][passanger.ticket[index]],
                },
              },
            ];
          }
        });
      }
      ticketWithPersons = [
        ...ticketWithPersons,
        { ticket: ticke, persons: ticketsForPersons },
      ];
    });
    return ticketWithPersons;
  },
);



// WEBPACK FOOTER //
// ./src/containers/Summary/selectors.js